import {DashboardTemplateConfig} from "../templates/templates-custom"
import ProjectLoader from "../../../../../core/manager/project/project-loader"
import ProjectViews from "../../../../../core/model2/project-view/project-views"
import {DashboardConfig} from "../../../../../core/gd-modules/dashboard/model/dashboard/dashboard-config"
import {ViewType} from "../../../../../core/gd/const/views/view-type"
import {ProjectViewAccess} from "../../../../../core/model2/project-view/@const"
import ProjectView from "../../../../../core/model2/project-view/project-view"
import {ProjectViewConfig} from "../../../../../core/model2/project-view/@types"
import ApiProject from "../../../../../core/gd/api/project"

// const debug = "createProjectDashboard"
const debug = false

export async function createProjectDashboard(projectId: ID, template: DashboardTemplateConfig, params?: any) {

    const dashboardName = params?.dashboardName || template.dashboardTitle || template.name

    debug && console.log(debug, 'process [A]', projectId, template)

    const projectLoader = new ProjectLoader(projectId);

    await projectLoader.isLoaded

    debug && console.log(debug, 'process [B]', projectLoader.project, projectLoader)

    const projectViews = ProjectViews.initByProjectId(projectId)

    const dashboardConfig : DashboardConfig = template.configFunction()

    if (params.parentProjectId) {
        const settings = {
            appSettings : dashboardConfig
        }

        const response = await ApiProject.newView({
            name            : dashboardName,
            color           : 1,
            parentProjectId : params.parentProjectId,
            projectIcon     : 'view-dashboard',
            settings        : {
                customView      : {
                    settings        : settings,
                    type            : ViewType.CUSTOM_VIEW_DASHBOARD
                }
            }
        }).promise()
        gd.navigation.goToProject(response.projectId)
    } else {
        const projectViewConfig: ProjectViewConfig = {
            systemType      : ViewType.PROJECT_DASHBOARD,
            name            : dashboardName,
            access          : ProjectViewAccess.PUBLIC,
        }

        const newProjectView : ProjectView = await projectViews.createView(projectViewConfig)
        newProjectView.saveAppSettings(dashboardConfig)
        await projectViews.save()

        gd.goTo(newProjectView.url)
    }
}